import {IStyle} from 'fela'
import {useFela} from 'react-fela'
import {useHistory} from 'react-router-dom'
import {Theme} from '../../../app/theme'
import {navigate} from './navigate'

interface Props {
  name: string
  link: string
  accent?: boolean
  underline?: boolean
  bold?: boolean
  color?: string
  onClick?: () => void
}

export function ArLink({name, link, accent, underline = true, bold = false, color, onClick}: Props) {
  const {css, theme} = useFela<Theme>()
  const history = useHistory()
  const linkColor = color ?? (accent ? theme.colors.accent : theme.colors.primaryLight)
  const style: IStyle = {
    textDecoration: underline ? 'underline' : 'none',
    fontWeight: bold ? 'bold' : 'normal',
    color: linkColor,
    '&:visited': {
      color: linkColor,
    },
    '&:hover': {
      color: linkColor,
    },
    '&:active': {
      color: linkColor,
    },
  }
  return (
    <a
      className={css(style)}
      href={link}
      onClick={(e) => {
        e.preventDefault()
        onClick?.()
        navigate(link, history)
      }}
    >
      {name}
    </a>
  )
}
